jQuery(function($){

	//===============================
	// Delete Posts 
	//===============================

	let onclickParent = '.block-editor, .sc-field-editor';

	//Remove Button
	$(onclickParent).on('click', '.delete-post .select-popup-button.remove', function(event){
		$(this).closest('.delete-post').addClass('show-confirmation');
	});

	//Cancel Remove
	$(onclickParent).on('click', '.delete-post .select-popup-button.cancel', function(event){
		$(this).closest('.delete-post').removeClass('show-confirmation');
	});

	//Remove Confirm
	$(onclickParent).on('click', '.delete-post .select-popup-button.remove-confirm', function(event) {
		$(this).closest('form').submit();
	});

	$('form').each((i, el) => {
		let childDivs = $(el).find('.sc-field-editor');
		let parentDiv = $(el).closest('.sc-field-editor');

		if(childDivs.length || parentDiv.length) {
			$(el).attr('novalidate', true).addClass('scfe-form');
		}
	});

	$('form.scfe-form input[type="submit"]').on('click', (e) => {
		let button = $(e.currentTarget);
		if(button.attr('name') && button.val()) {
			button.closest('form').append('<input type="hidden" name="' + button.attr('name') + '" value="' + button.val() + '">');
		}
	});

	$('form.scfe-form').on('submit', (e) => {
		let form = $(e.currentTarget);
		if(!form.hasClass('scfe-validation-passed')) {
			e.preventDefault();

			let invalidFields = [];
			form.find('[required]:not(div.value)').each((i, el) => {
				if(!$(el).val() || ($(el).hasClass('typeahead-value')) && $(el).val() == '[]') {
					let parentDiv = $(el).closest('.field');
					parentDiv.addClass('scfe-invalid');

					let fieldsParent = $(el).closest('.fields');
					if(fieldsParent.hasClass('has-tabs')) {
						assignTabsInvalidStatus(fieldsParent, 'invalid');
					}

					console.log($(el));
					console.log(parentDiv);

					//Field name
					let label = atob(parentDiv.attr('field_label'));
					if(!label) {
						const fullFieldName = parentDiv.attr('full_field_name');
						if(fullFieldName) {
							const labelEl = parentDiv.find('label[for="' + fullFieldName + '"]');
							label = labelEl.attr('label_text') ? labelEl.attr('label_text') : labelEl.html();
						}
					}
					if(!label) {
						label = parentDiv.attr('field_name');
					}

					invalidFields.push(label);
				}
			});

			setTimeout(() => {
				if(invalidFields.length) {
					form.removeClass('scfe-validation-passed');
					let alertMessage = 'Cannot submit form, required fields are blank:';
					let bulletPoint = "\n\u00A0\u2022\u00A0\u00A0";

					console.log(invalidFields);

					$.each(invalidFields, (i, val) => {
						alertMessage += bulletPoint + val;
					});

					window.alert(alertMessage);
				} else {
					form.addClass('scfe-validation-passed').submit();
				}
			}, 50);
		} else if(form.hasClass('no-submit')) {
			e.preventDefault();
		}
	});

	function assignTabsInvalidStatus(fieldsParent, status, onlyRemoveInvalid = false) {
		let targets = [];
		fieldsParent.find('.scfe-tab.active').each((i, el) => {
			targets.push($(el).attr('target'));
		});

		let formParent = fieldsParent.closest('.scfe-form');
		$.each(targets, (i, val) => {
			formParent.find('.scfe-tab[target="' + val + '"]').each((j, el) => {
				if(status == 'invalid' && !onlyRemoveInvalid) {
					$(el).addClass('has-invalid');
				} else {
					$(el).removeClass('has-invalid');
				}
			});
		});
	}

	$('form.scfe-form [required]').on('change', (e, el) => {
		let field = $(e.currentTarget);
		if(field.val()) {
			let parentDiv = field.closest('.field');
			if(parentDiv.hasClass('scfe-invalid')) parentDiv.removeClass('scfe-invalid');

			let tabStatus = 'valid';
			let fieldsParent = parentDiv.closest('.fields');
			if(fieldsParent.hasClass('has-tabs')) {
				// console.log(fieldsParent.find('[required]'));
				fieldsParent.find('[required]').each((i, el) => {
					// console.log(i, $(el).val(), $(el));

					//If add new fields child field
					const addNewFieldsParent = $(el).closest('.add-new-fields');
					if(addNewFieldsParent.length && !addNewFieldsParent.hasClass('visible')) return;

					if(!$(el).val()) {
						console.log(i, $(el).val(), $(el));
						tabStatus = 'invalid';
					}
				});

				assignTabsInvalidStatus(fieldsParent, tabStatus, true);
			}
		}
	});

	//===============================
	// Misc
	//===============================

	//Don't go anywhere with urls
	$('.block-editor').on('click', '.wp-block-post-content a', function(e){
		e.preventDefault();
	});

	//Color Picker
	$('.sc-field-editor .color-picker-input').iris({
		hide: false,
		change: function(event, ui) {
			let parentDiv = $(event.target).closest('.color-picker');
			let display = $(parentDiv).find('.color-picker-display');
			const colorHex = ui.color.toString();
			display.css('background', colorHex).html('<span>' + colorHex + '</span>').show();
			if(parentDiv.find('.predefined-colors').length) {
				const colorsDropdown = parentDiv.find('.predefined-colors');
				colorsDropdown.find('option').attr('selected', false);
				colorsDropdown.find('option').each(function(){
					if(colorHex == $(this).val()) $(this).attr('selected', true);
				});
			}
		}
	});

	$('.sc-field-editor .field.color-picker').on('change', '.predefined-colors', function(){
		let parentDiv = $(this).closest('.color-picker');
		parentDiv.find('.color-picker-input').val($(this).val()).trigger('change');
	});

	//Datepicker
	const datepickerOnclickParent = onclickParent + ', .sc-theme-frontend';
	$(datepickerOnclickParent).on('focus', 'input.datepicker', function(e){

		if(!$(this).hasClass('datepicker-init')) {
			$(this).datepicker();
			$(this).datepicker('destroy');
			$(this).addClass('datepicker-init');
		}

		let el = $(this);
		$(this).datepicker({
			showOtherMonths: true,
			dateFormat: 'yy-mm-dd',
			altFormat: 'yymmdd',
			changeMonth: true,
			changeYear: true,
			yearRange: 'c-100:c+5',
			beforeShow: function(input, inst) {
				inst.dpDiv.addClass('sc-field-editor-datepicker');
			},
			onSelect: function(value, datepicker) {
				let altFormat = datepicker.selectedYear.toString() + zeroPad(datepicker.selectedMonth + 1) + zeroPad(datepicker.selectedDay);
				let hiddenField = $(this).closest('.value').find('.datepicker-value');
				hiddenField.val(altFormat);
				el.change();
			}
		});
	});

	$(datepickerOnclickParent).on('change', 'input.datepicker', function(){
		let el = $(this);
		var rawValue = !$(this).val() ? '' : $(this).val().replaceAll('-', '');
		$(this).closest('.field').find('.datepicker-value').val(rawValue).change();
		setTimeout(function(){
			el.datepicker('destroy');
		}, 200);
	});


	function zeroPad(num) {
		var zero = 2 - num.toString().length + 1;
		return Array(+(zero > 0 && zero)).join("0") + num;		
	}

	//Checkbox
	$(onclickParent).on('change', 'input.true-false', function(){
		let trueValue = $(this).attr('true_value');
		let falseValue = $(this).attr('false_value');

		if(typeof trueValue === 'undefined') trueValue = 'on';
		if(typeof falseValue === 'undefined') falseValue = '';

		const value = $(this).prop('checked') ? trueValue : falseValue;
		const fieldName = $(this).closest('.field').attr('full_field_name');
		$(this).closest('.field').find('input[name="' + fieldName + '"]').val(value);
	});

	//Tabs
	$('.scfe-tab').on('click', function(){
		console.log('clicked');
		let target = $(this).attr('target');
		$(this).closest('.sc-field-editor').find('.fields').each(function(){
			$(this).removeClass('active-tab-section');
		});

		$('#' + target).addClass('active-tab-section');
	});

	$('.sc-field-editor .edit-form').on('mouseover', '.fields .field label .tooltip-icon', function(){
		$(this).closest('.field').addClass('show-tooltip');
	});

	$('.sc-field-editor .edit-form').on('mouseout', '.fields .field label .tooltip-icon', function(){
		$(this).closest('.field').removeClass('show-tooltip');
	});

	$('.sc-field-editor .edit-form').on('change', '.fields .field.checkbox-list input[type="checkbox"]:not(.hidden-checkbox)', function(){
		const parentDiv = $(this).closest('.field.checkbox-list');

		setTimeout(function(){
			let optionsChecked = false;
			parentDiv.find('input[type="checkbox"]:not(.hidden-checkbox)').each(function(){
				if(this.checked) optionsChecked = true;
			});

			if(optionsChecked) {
				parentDiv.find('input.hidden-checkbox').each(function(){
					this.checked = false;
					$(this).attr('checked', false); 
				});
			} else {
				parentDiv.find('input.hidden-checkbox').each(function(){
					this.checked = true;
					$(this).attr('checked', true); 
				});
			}
		}, 50);

	});

	function setEditorNotificationHeight() {
		console.log('RUNNING');
		if(notificationHeightLoopCounter > notificationHeightLoopLimit) clearTimeout(notificationHeightLoop);

		if($('body.block-editor-page .components-notice-list').length) {
			const styles = getComputedStyle(document.body);
			const cssVarName = '--wp-notification-height';
			const cssValue = styles.getPropertyValue(cssVarName);
			console.log(cssVarName, cssValue);

			if(cssValue.trim() !== '') {
				console.log('Block editor height set');
				clearTimeout(notificationHeightLoop)
			} else {
				const list = $('body.block-editor-page .components-notice-list');
				let notificationHeight = 0;
				list.each(function(){
					notificationHeight += $(this).height();
					console.log($(this));
					console.log($(this).height());
				});
				const heightPx = notificationHeight + 'px';
				$('body').css(cssVarName, heightPx);
			}
		} else {
			console.log('Not a block editor page');
			clearTimeout(notificationHeightLoop)
		}
		notificationHeightLoopCounter++;
	}

	let notificationHeightLoop = setInterval(setEditorNotificationHeight, 250);
	let notificationHeightLoopLimit = 8;
	let notificationHeightLoopCounter = 0;
	$(document).on('click', '.components-button.components-notice__dismiss', function(){
		const cssVarName = '--wp-notification-height';
		$('body').css(cssVarName, '');
		setTimeout(function(){
			setEditorNotificationHeight();
		}, 50);
	});
});